import { useAppTranslation } from '../i18n/useAppTranslation';
import React, { useState } from 'react';
import { Alert, Box, Button, Stack, TextField, Typography } from '@mui/material';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function ChangePassword() {
  const { tr } = useAppTranslation();
  const { logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const submit = async (event: React.FormEvent) => {
    event.preventDefault(); setError('');
    if (password !== confirmation) { setError('Les mots de passe ne correspondent pas.'); return; }
    setBusy(true);
    try {
      await api.post('/users/change-password/', { current_password: current, new_password: password });
      setCurrent(''); setPassword(''); setConfirmation(''); setSuccess(true);
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    } catch (err: any) { setError(String(err.response?.data?.error || err.response?.data?.detail || 'Impossible de modifier le mot de passe.')); }
    finally { setBusy(false); }
  };
  return <Box sx={{ mt: 4, pt: 3, borderTop: 1, borderColor: 'divider' }}>
    <Typography variant="h6" component="h2" gutterBottom>{tr("Changer mon mot de passe")}</Typography>
    {success ? <><Alert severity="success">{tr("Mot de passe modifié. Reconnectez-vous avec votre nouveau mot de passe.")}</Alert><Button onClick={() => logout('/login')} sx={{ mt: 2 }}>{tr("Se reconnecter")}</Button></> :
      <Stack component="form" onSubmit={submit} spacing={2} sx={{ maxWidth: 480 }}>
        {error && <Alert severity="error">{tr(error)}</Alert>}
        <TextField required type="password" autoComplete="current-password" label={tr("Mot de passe actuel")} value={current} onChange={event => setCurrent(event.target.value)} />
        <TextField required type="password" autoComplete="new-password" label={tr("Nouveau mot de passe")} helperText={tr("Au moins 8 caractères, différent de vos informations personnelles.")} inputProps={{ minLength: 8 }} value={password} onChange={event => setPassword(event.target.value)} />
        <TextField required type="password" autoComplete="new-password" label={tr("Confirmer le nouveau mot de passe")} value={confirmation} onChange={event => setConfirmation(event.target.value)} />
        <Button type="submit" variant="outlined" disabled={busy}>{tr("Modifier mon mot de passe")}</Button>
      </Stack>}
  </Box>;
}
